import type { MouseEvent, FocusEvent } from 'react';
import { LoadingSpinner } from '@simplywallst/ui-core';
import type { ColorTheme } from './styled';
import { ResetIcon, SearchSpinner } from './styled';

interface Props {
  searchStatus?: 'success' | 'pending' | 'error';
  searchQuery: string;
  styleType?: ColorTheme;
  onReset: (e: MouseEvent) => void;
  onFocus?: (e: FocusEvent) => void;
  isFetching?: boolean;
}

const SearchFieldPostfix = ({
  searchStatus,
  isFetching,
  searchQuery,
  styleType,
  onReset,
  onFocus,
}: Props) => {
  return searchQuery !== '' && (isFetching || searchStatus === 'pending') ? (
    <SearchSpinner data-cy-id="search-field-searching">
      <LoadingSpinner styleType="light" />
    </SearchSpinner>
  ) : searchQuery.length > 0 ? (
    <ResetIcon
      tabIndex={0}
      onFocus={(e: FocusEvent) => {
        if (onFocus) onFocus(e);
      }}
      onClick={onReset}
      color={styleType}
      data-cy-id="search-field-reset"
    />
  ) : null;
};

export default SearchFieldPostfix;
